export default __webpack_public_path__ + "static/media/athletes-of-the-week-icon.de2746a0.svg";